import Preloader from "../../components/Preloader";
import { Suspense, lazy } from "react";
import DynamicForm from "../../components/dynamic-form";
import DeathForm from "../../components/IPD/modals/DeathForm";
import ChangeRoomServices from "../../components/IPD/services/ChangeRoomServices";
import Instruction from "../../pages/OPD/Admin/instruction";
import InstructionEditor from "../../pages/OPD/Admin/instruction/InstructionEditor";
import HeaderFooterComponent from "../../pages/HeaderFooter/Index";
import TabbedForm from "../../components/IPD/modals/other-tabs";
import Template from "../../pages/IPD/template";
import HospitalStatistics from "../../pages/hospital_stats";
import Dsage from "../../components/OPD/add-new-medicine/dosage";
import ReportTemplates from "../../pages/OPD/Admin/report-templates";
import CheckedOption from "../../components/access-config/checked-option";
import OnlineRevenue from "../../pages/Super-Admin/onlineAppointment";
import Antibiotic from "../../pages/IPD/antibiotic";
import BloodDonor from "../../pages/blood-donor";
import DonorHistory from "../../pages/blood-donor/DonorHistory";
import BloodProducts from "../../pages/blood-donor/settings/blood-products";
import PatientSlipForm from "../../pages/blood-donor/settings/patient-slip/PatientSlipForm";
import BagGeneration from "../../pages/blood-donor/bag";
import DonorScreening from "../../pages/blood-donor/donor-screening";
import DonorScreeningTable from "../../pages/blood-donor/donor-screening/donor-screening-table";
import BloodCrossmatch from "../../pages/blood-donor/blood-crossmatch";
import CrossMatchReport from "../../pages/blood-donor/blood-crossmatch/cross-match-report";
import RegForm from "../../pages/slotPatientRegForm";
import DoctorCards from "../../pages/alldoctor/Index";
import TimeSlots from "../../components/slots";
import PatientAppointment from "../../pages/slotappointment";
import Questions from "../../pages/blood-donor/settings/questions";
import PaymentStatement from "../../pages/blood-donor/settings/payment-statement";
import DonorBagExpiry from "../../pages/blood-donor/donor-bag-expiry";
import BloodDonorPageHeader from "../../pages/blood-donor/page-header";

// import ExpenseCategory from "../../pages/expenses/expense-category";
import AvailableStock from "../../pages/blood-donor/AvailableStock";
import LabSettings from "../../pages/lab/settings";
import NewLabSettings from "../../pages/lab/labSettings";
import TestComponent from "../../pages/lab/test";
import SampleCollection from "../../pages/lab/sample-collection";
import Samples from "../../pages/lab/samples";
import AddTestResult from "../../pages/lab/test-results/add-test";
// import LabDashboard from "../../pages/lab";
import AccountSettings from "../../pages/acount/setting";
// import IncomeCategory from "../../pages/acount/income";
import ExpenseCategory from "../../pages/acount/expenses";
import IncomeManagement from "../../pages/acount/incomeManagement";
import AcountDashboard from "../../pages/acount";
import IncomeExpeseSetting from "../../pages/income&Expense/setting";
import IncomeCategory from "../../pages/income&Expense/income";
import DeletedIncomeHistory from "../../pages/income&Expense/income/deleteHistory";
import ExpensePaymentsPage from "../../pages/income&Expense/expense-payments";
import Lab from "../../pages/lab";
import BloodBankSettings from "../../pages/blood-Bank/settings";
import BloodBankDashboard from "../../pages/blood-Bank/dashboard";
const LabExpense = lazy(() => import("../../pages/lab/lab-expense"));
const Pharmacy = lazy(() => import("../../pages/pharmacy"));
const HospitalReports = lazy(() => import("../../pages/hospital-reports"));
const IpdAdmissionRegister = lazy(() =>
  import("../../pages/hospital-reports/ipd-admission-register")
);
const PatientRecordRegister = lazy(() =>
  import("../../pages/hospital-reports/patient-record-register")
);
const RadiologySummary = lazy(() =>
  import("../../pages/hospital-reports/radiology-summary")
);
// import IncomeExpeseSetting from "../../pages/income&Expense";



const MedicineAdministration = lazy(() =>
  import("../../components/OPD/add-new-medicine/adminstration")
);

const ReferralForm = lazy(() => import("../../components/OPD/refered-slip"));
const Department = lazy(() => import("../../pages/IPD/department"));
const Services = lazy(() => import("../../pages/IPD/services"));
const DashboardForm = lazy(() => import("../../pages/IPD/dashboard-form"));
const Dashboard = lazy(() => import("../../pages/IPD/dashboard"));
const AdmissionInformation = lazy(() =>
  import("../../pages/IPD/dashboard-form/admission information")
);
const EmergencyForm = lazy(() =>
  import("../../components/IPD/ipd-dashboard/emergency-form")
);
const Infrastructure = lazy(() => import("../../pages/IPD/infrastructure"));
const OPDDashboard = lazy(() => import("../../pages/OPD/opd-dashboard"));
const DiagnosticServices = lazy(() =>
  import("../../pages/OPD/diagnostic-services")
);
const AddPatientRecords = lazy(() =>
  import("../../components/OPD/add-patient-record")
);
const USGEchoPage = lazy(() => import("../../pages/OPD/usg-echo"));
const Diagnoses = lazy(() => import("../../pages/OPD/Admin/diagnosis"));
const Procedure = lazy(() => import("../../pages/OPD/Admin/Procedure"));
const Symptoms = lazy(() => import("../../pages/OPD/Admin/symptoms"));
const CaseDashboard = lazy(() => import("../../pages/OPD/Admin/case"));
const AddCaseForm = lazy(() => import("../../components/OPD/add-case-form"));
const Generic = lazy(() => import("../../pages/OPD/Admin/generic"));
const AddVitals = lazy(() => import("../../components/AddVitals"));
const MedicineSchedule = lazy(() =>
  import("../../components/OPD/add-new-medicine/medicine-schedule")
);
const AddNewMedicine = lazy(() =>
  import("../../components/OPD/add-new-medicine")
);
const FormDataEntry = lazy(() =>
  import("../../components/Pathology_comp/add-new-test/add-test")
);
const Medicine = lazy(() => import("../../pages/OPD/Admin/medicine"));
const EmployeDepartment = lazy(() =>
  import("../../pages/emplye-page/add-department")
);
const EmpShift = lazy(() => import("../../components/employ/emp-shift"));
const AddNewAdmins = lazy(() =>
  import("../../components/super-admin/add-new-admin")
);
const AttachFile = lazy(() => import("../../components/employ/attatch-file"));
const AddNewTest = lazy(() =>
  import("../../components/Pathology_comp/add-new-test")
);
const Home = lazy(() => import("../../pages/Home"));
const Patients = lazy(() => import("../../pages/Patients"));
const PatientRegistrationome = lazy(() =>
  import("../../pages/reg-form/RegForms")
);
const Employ = lazy(() => import("../../components/employ/BodyCard"));

const HospitalRecords = lazy(() => import("../../pages/hospital-records"));

const AddEmploye = lazy(() =>
  import("../../pages/emplye-page/add-employe/add-employe-form")
);
const EmployeCategory = lazy(() =>
  import("../../pages/emplye-page/emp-category")
);
const EmployeDetails = lazy(() =>
  import("../../pages/emplye-page/add-employe/emp-detail-form")
);
const UserReports = lazy(() => import("../../pages/reports/user-reports"));
const Insurances = lazy(() => import("../../pages/Insurance/Insurances"));
const InsuranceDashboard = lazy(() =>
  import("../../pages/Insurance/dashboard")
);
const EmpServices = lazy(() => import("../../components/AddEmpServices"));
const Companies = lazy(() =>
  import("../../pages/Insurance/Companies/company-dashboard")
);
const AddNewCompany = lazy(() =>
  import("../../pages/Insurance/Companies/add-new")
);
const ViewCompany = lazy(() =>
  import("../../pages/Insurance/Companies/view")
);
const PathologyDashboard = lazy(() =>
  import("../../pages/pathalogy/dashboard")
);
const RegisterPathology = lazy(() => import("../../pages/pathalogy/register"));
const PathologyRegistration = lazy(() =>
  import("../../components/PathologyRegistration")
);
const ReportTable = lazy(() =>
  import("../../components/PathologyRegistration/report-table")
);
const InsuranceServices = lazy(() => import("../../pages/Insurance/Services"));
const InsuranceReports = lazy(() =>
  import("../../pages/Insurance/Insurances/insurance-reports")
);
const InsuranceCards = lazy(() =>
  import("../../pages/Insurance/InsuranceCards")
);
const InsuranceCardForm = lazy(() =>
  import("../../pages/Insurance/InsuranceCards/add")
);
const InsuranceSettings = lazy(() => import("../../pages/Insurance/Settings"));
const InsuranceOtherSettings = lazy(() =>
  import("../../pages/Insurance/Settings/other-settings")
);
const CompanyBillingTemplates = lazy(() =>
  import("../../pages/Insurance/Settings/company-billing-templates")
);
const LabBillingTemplates = lazy(() =>
  import("../../pages/Insurance/Settings/lab-billing-templates")
);
const MedicineBillingTemplates = lazy(() =>
  import("../../pages/Insurance/Settings/medicine-billing-templates")
);
const InsuranceCases = lazy(() =>
  import("../../pages/Insurance/InsuranceCases")
);
const InsuranceCaseForm = lazy(() =>
  import("../../pages/Insurance/InsuranceCases/add")
);
const InsuranceBillings = lazy(() => import("../../pages/Insurance/Billings"));
const InsuranceBillingForm = lazy(() =>
  import("../../pages/Insurance/Billings/add")
);
const InsuranceLabBillForm = lazy(() =>
  import("../../pages/Insurance/Billings/lab/add")
);
const InsuranceLabBillEdit = lazy(() =>
  import("../../pages/Insurance/Billings/lab/edit")
);
const InsuranceMedicineBillForm = lazy(() =>
  import("../../pages/Insurance/Billings/medicine/add")
);
const InsuranceMedicineBillEdit = lazy(() =>
  import("../../pages/Insurance/Billings/medicine/edit")
);
const SuperAdmin = lazy(() => import("../../pages/Super-Admin/dashboard"));
const FlaggedHospitals = lazy(() => import("../../pages/Super-Admin/flagged-hospitals"));
const NewAdmin = lazy(() => import("../../pages/Super-Admin/new-admin"));
const AddNewAdmin = lazy(() =>
  import("../../components/super-admin/add-new-admin-form")
);
const DefaultConfig = lazy(() =>
  import("../../components/access-config/default-configs")
);
const AccessConfigID = lazy(() => import("../../components/access-config"));
const AccessConfig = lazy(() => import("../../pages/AccessConfig"));
const UserProfile = lazy(() => import("../../pages/UserProfile"));
const ComponentWithTabs = lazy(() =>
  import("../../components/Pathology_comp/depart-units")
);
const DeleteHistory = lazy(() => import("../../pages/DeleteHistory"));
// const Analysis = lazy(() => import("../../pages/pathalogy/analysis"));
const TestResult = lazy(() => import("../../pages/lab/test-results"));
const CriticalReports = lazy(() => import("../../pages/lab/test-results/critical-reports"));
const PRRE = lazy(() => import("../../pages/pathalogy/PR&RE"));
const DepartmentsAndLocations = lazy(() =>
  import("../../pages/Departments&Locations")
);
const StockManagement = lazy(() => import("../../pages/StockManagement"));
const AddAsset = lazy(() => import("../../pages/AddAssets"));
const AddTests = lazy(() =>
  import("../../pages/pathalogy/test-results/test-list/add-tests")
);
const NotFound = lazy(() => import("../../pages/404"));

// by azam
const MyEmploy = lazy(() =>
  import("../../pages/my-employe-page/emp-dashboard")
);

const NewEmployee = lazy(() =>
  import("../../pages/my-employe-page/new-employe")
);

const PrivatePaths = [
  {
    path: "/super-admin-dashboard",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <SuperAdmin />
      </Suspense>
    ),
  },
  {
    path: "/flagged-hospitals",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <FlaggedHospitals />
      </Suspense>
    ),
  },
  {
    path: "/hospital_dashboard",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <HospitalStatistics />
      </Suspense>
    ),
  },
  {
    path: "/register-new-admin",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewAdmin />
      </Suspense>
    ),
  },
  {
    path: "/register-new-admin/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewAdmin />
      </Suspense>
    ),
  },
  {
    path: "/new-admins",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewAdmins />
      </Suspense>
    ),
  },
  {
    path: "/new-admins/:id/:name",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewAdmins />
      </Suspense>
    ),
  },
  {
    path: "/all-admins",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <NewAdmin />
      </Suspense>
    ),
  },
  {
    path: "/online-revenue",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <OnlineRevenue />
      </Suspense>
    ),
  },
  {
    path: "/appointment-dashboard",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Home />
      </Suspense>
    ),
  },
  // {
  //   path: '/update-patient',
  //   Content: () => (
  //     <Suspense fallback={<Preloader/>}>
  //       <Patients />
  //     </Suspense>
  //   )
  // },
  {
    path: "/patient-registration",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PatientRegistrationome />
      </Suspense>
    ),
  },
  {
    path: "/patient-registration-slot",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <RegForm />
      </Suspense>
    ),
  },
  {
    path: "/patient-registration:appointment",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PatientRegistrationome />
      </Suspense>
    ),
  },
  {
    path: "/doc_card",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DoctorCards />
      </Suspense>
    ),
  },
  {
    path: "/patient_Appointment_slot",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PatientAppointment />
      </Suspense>
    ),
  },
  // {
  //   path: "/employe",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <Employ />
  //     </Suspense>
  //   ),
  // },

  {
    path: "/employee",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <MyEmploy />
      </Suspense>
    ),
  },
  {
    path: "/add-employe/:tab",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <NewEmployee />
      </Suspense>
    ),
  },
  {
    path: "/add-employe/:tab/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <NewEmployee />
      </Suspense>
    ),
  },
  {
    path: "/add-employe/:tab/:id/:name",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <NewEmployee />
      </Suspense>
    ),
  },

  {
    path: "/employe-category",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <EmployeCategory />
      </Suspense>
    ),
  },
  {
    path: "/employe-add",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddEmploye />
      </Suspense>
    ),
  },
  {
    path: "/employe-add/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddEmploye />
      </Suspense>
    ),
  },
  {
    path: "/add-shift/:id/:name",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <EmpShift />
      </Suspense>
    ),
  },
  {
    path: "/add-employe-details/:id/:name",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <EmployeDetails />
      </Suspense>
    ),
  },
  {
    path: "/add-department",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <EmployeDepartment />
      </Suspense>
    ),
  },

  {
    path: "/hospital-records",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <HospitalRecords />
      </Suspense>
    ),
  },
  {
    path: "/user-reports",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <UserReports />
      </Suspense>
    ),
  },
  {
    path: "/insurances",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Insurances />
      </Suspense>
    ),
  },
  {
    path: "/insurance-dashboard",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceDashboard />
      </Suspense>
    ),
  },
  {
    path: "/companies",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Companies />
      </Suspense>
    ),
  },
  {
    path: "/attatch-file/:id/:name",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AttachFile />
      </Suspense>
    ),
  },
  {
    path: "/emp-services/:empId/:name",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <EmpServices />
      </Suspense>
    ),
  },
  {
    path: "/add-new-company",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewCompany />
      </Suspense>
    ),
  },
  {
    path: "/edit-company/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewCompany />
      </Suspense>
    ),
  },
  {
    path: "/view-company/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <ViewCompany />
      </Suspense>
    ),
  },

  {
    path: "/insurance-services",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceServices />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceSettings />
      </Suspense>
    ),
  },
  {
    path: "/insurance-id-types",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceOtherSettings />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/companies",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Companies />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/companies/add",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewCompany />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/companies/edit/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewCompany />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/companies/view/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <ViewCompany />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/add-services",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceServices />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/id-types",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceOtherSettings />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/other-settings",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceOtherSettings />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/company-billing-templates",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <CompanyBillingTemplates />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/lab-billing-templates",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <LabBillingTemplates />
      </Suspense>
    ),
  },
  {
    path: "/insurance-settings/medicine-billing-templates",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <MedicineBillingTemplates />
      </Suspense>
    ),
  },
  {
    path: "/insurance-cards",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceCards />
      </Suspense>
    ),
  },
  {
    path: "/insurance-cards/add",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceCardForm />
      </Suspense>
    ),
  },
  {
    path: "/insurance-cards/edit/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceCardForm />
      </Suspense>
    ),
  },
  {
    path: "/insurance-cases",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceCases />
      </Suspense>
    ),
  },
  {
    path: "/insurance-cases/add",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceCaseForm />
      </Suspense>
    ),
  },
  {
    path: "/insurance-cases/edit/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceCaseForm />
      </Suspense>
    ),
  },
  {
    path: "/insurance-billings",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceBillings />
      </Suspense>
    ),
  },
  {
    path: "/insurance-billings/add",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceBillingForm />
      </Suspense>
    ),
  },
  {
    path: "/insurance-billings/edit/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceBillingForm />
      </Suspense>
    ),
  },
  {
    path: "/insurance-billings/lab/add",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceLabBillForm />
      </Suspense>
    ),
  },
  {
    path: "/insurance-billings/lab/edit/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceLabBillEdit />
      </Suspense>
    ),
  },
  {
    path: "/insurance-billings/medicine/add",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceMedicineBillForm />
      </Suspense>
    ),
  },
  {
    path: "/insurance-billings/medicine/edit/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceMedicineBillEdit />
      </Suspense>
    ),
  },
  {
    path: "/report-table",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <ReportTable />
      </Suspense>
    ),
  },
  {
    path: "/insurance-reports",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InsuranceReports />
      </Suspense>
    ),
  },
  // 
  {
    path: "/account-setting/:tab",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AccountSettings />
      </Suspense>
    ),
  },
  {
    path: "/account/:tab",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AcountDashboard />
      </Suspense>
    ),
  },
  {
    path: "/income&expense/:tab",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <IncomeExpeseSetting />
      </Suspense>
    ),
  },
  {
    path: "/income&expense/income",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        < IncomeCategory />
      </Suspense>
    ),
  },
  {
    path: "/income&expense/income-delete-history",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        < DeletedIncomeHistory />
      </Suspense>
    ),
  },
  {
    path: "/income&expense/expense",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <ExpenseCategory />
      </Suspense>
    ),
  },
  {
    path: "/income&expense/expense-payments",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <ExpensePaymentsPage />
      </Suspense>
    ),
  },
  {
    path: "/expense-payments",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <ExpensePaymentsPage />
      </Suspense>
    ),
  },
  {
    path: "/account/income",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <IncomeManagement />
      </Suspense>
    ),
  },
  {
    path: "/account/expense",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <ExpenseCategory />
      </Suspense>
    ),
  },
  {
    path: "/access-config",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AccessConfig />
      </Suspense>
    ),
  },
  {
    path: "/user-access/:id/:name",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AccessConfigID />
      </Suspense>
    ),
  },
  {
    path: "/default-config",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DefaultConfig />
      </Suspense>
    ),
  },
  {
    path: "/default-header-footer",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <HeaderFooterComponent />
      </Suspense>
    ),
  },
  {
    path: "/disposal-option",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <CheckedOption />
      </Suspense>
    ),
  },
  // {
  //   path: "/dynamic-form",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <DynamicForm />
  //     </Suspense>
  //   ),
  // },
  {
    path: "/:tabname?/:id?",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <UserProfile />
      </Suspense>
    ),
  },
  {
    path: "/delete-history",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DeleteHistory />
      </Suspense>
    ),
  },
  // Pathology
  {
    path: "/mylab/:tab",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Lab />
      </Suspense>
    ),
  },
  {
    path: "/lab-settings/:tab",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <NewLabSettings />
      </Suspense>
    ),
  },
  {
    path: "/lab-settings",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <NewLabSettings />
      </Suspense>
    ),
  },
  {
    path: "sample-collection",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <SampleCollection />
      </Suspense>
    ),
  },
  {
    path: "sample",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Samples />
      </Suspense>
    ),
  },

  // {
  //   path: "/add-new-test",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <AddNewTest />
  //     </Suspense>
  //   ),
  // },
  // {
  //   path: "/add-new-test/:id",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <AddNewTest />
  //     </Suspense>
  //   ),
  // },

  {
    path: "/settings/:tab",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <LabSettings />
      </Suspense>
    ),
  },
  {
    path: "/add-test-result",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddTestResult />
      </Suspense>
    ),
  },


  //add-test-result
  {
    path: "/test-tab/:tab",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <TestComponent />
      </Suspense>
    ),
  },
  {
    path: "/test-tab/:tab/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <TestComponent />
      </Suspense>
    ),
  },
  {
    path: "/depart-units-1",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <FormDataEntry />
      </Suspense>
    ),
  },
  {
    path: "/pathology-register",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <RegisterPathology />
      </Suspense>
    ),
  },
  // {
  //   path: "/pathology-registration",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <PathologyRegistration />
  //     </Suspense>
  //   ),
  // },
  {
    path: "/patient-registration-and-test-entry",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PRRE />
      </Suspense>
    ),
  },
  {
    path: "/patient-registration-and-test-entry/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PRRE />
      </Suspense>
    ),
  },

  {
    path: "/departments-and-locations",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DepartmentsAndLocations />
      </Suspense>
    ),
  },
  {
    path: "/stock-management",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <StockManagement />
      </Suspense>
    ),
  },
  {
    path: "/add-assets",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddAsset />
      </Suspense>
    ),
  },
  // {
  //   path: "/pathology-analysis",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <Analysis />
  //     </Suspense>
  //   ),
  // },
  {
    path: "/add-test-result/:testId/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddTests />
      </Suspense>
    ),
  },
  {
    path: "/test-result",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <TestResult />
      </Suspense>
    ),
  },
  {
    path: "/critical-reports",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <CriticalReports />
      </Suspense>
    ),
  },
  {
    path: "/lab-expense",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <LabExpense />
      </Suspense>
    ),
  },

  // // // OPD

  {
    path: "/opd-admin",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Medicine />
      </Suspense>
    ),
  },
  // Eye OPD routes (duplicates of OPD routes, prefixed with /eye)
  {
    path: "/eye/opd-admin",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Medicine />
      </Suspense>
    ),
  },
  {
    path: "/add-new-medicine",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewMedicine />
      </Suspense>
    ),
  },
  {
    path: "/eye/add-new-medicine",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddNewMedicine />
      </Suspense>
    ),
  },
  {
    path: "/opd-dashboard",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <OPDDashboard />
      </Suspense>
    ),
  },
  {
    path: "/diagnostic-services",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DiagnosticServices />
      </Suspense>
    ),
  },
  {
    path: "/eye/opd-dashboard",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <OPDDashboard />
      </Suspense>
    ),
  },
  {
    path: "/eye/diagnostic-services",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DiagnosticServices />
      </Suspense>
    ),
  },
  {
    path: "/add-patient-record/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddPatientRecords />
      </Suspense>
    ),
  },
  {
    path: "/usg-echo/:appointmentId",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <USGEchoPage />
      </Suspense>
    ),
  },
  {
    path: "/eye/add-patient-record/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddPatientRecords />
      </Suspense>
    ),
  },
  {
    path: "/eye/usg-echo/:appointmentId",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <USGEchoPage />
      </Suspense>
    ),
  },
  // Diagnoses
  {
    path: "/diagnosis",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Diagnoses />
      </Suspense>
    ),
  },
  {
    path: "/eye/diagnosis",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Diagnoses />
      </Suspense>
    ),
  },
  {
    path: "/procedure",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Procedure />
      </Suspense>
    ),
  },
  {
    path: "/eye/procedure",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Procedure />
      </Suspense>
    ),
  },
  {
    path: "/symptoms",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Symptoms />
      </Suspense>
    ),
  },
  {
    path: "/eye/symptoms",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Symptoms />
      </Suspense>
    ),
  },
  {
    path: "/case-dashboard",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <CaseDashboard />
      </Suspense>
    ),
  },
  {
    path: "/eye/case-dashboard",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <CaseDashboard />
      </Suspense>
    ),
  },
  {
    path: "/add-case",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddCaseForm />
      </Suspense>
    ),
  },
  {
    path: "/eye/add-case",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddCaseForm />
      </Suspense>
    ),
  },
  {
    path: "/add-case/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddCaseForm />
      </Suspense>
    ),
  },
  {
    path: "/eye/add-case/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddCaseForm />
      </Suspense>
    ),
  },
  // {
  {
    path: "/generic",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Generic />
      </Suspense>
    ),
  },
  {
    path: "/eye/generic",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Generic />
      </Suspense>
    ),
  },
  {
    path: "/add-vitals",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddVitals />
      </Suspense>
    ),
  },
  {
    path: "/eye/add-vitals",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AddVitals />
      </Suspense>
    ),
  },
  {
    path: "/add-schedule",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <MedicineSchedule />
      </Suspense>
    ),
  },
  {
    path: "/eye/add-schedule",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <MedicineSchedule />
      </Suspense>
    ),
  },
  {
    path: "/adminstration",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <MedicineAdministration />
      </Suspense>
    ),
  },
  {
    path: "/eye/adminstration",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <MedicineAdministration />
      </Suspense>
    ),
  },
  {
    path: "/dosage",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Dsage />
      </Suspense>
    ),
  },
  {
    path: "/report-templates",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <ReportTemplates />
      </Suspense>
    ),
  },
  {
    path: "/eye/dosage",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Dsage />
      </Suspense>
    ),
  },

  // {
  //   path: "/referal-form",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <ReferralForm />
  //     </Suspense>
  //   ),
  // },
  // {
  //   path: "/referal-form/:id",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <ReferralForm />
  //     </Suspense>
  //   ),
  // },

  // IPD routes

  {
    path: "/infrastructure",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Infrastructure />
      </Suspense>
    ),
  },
  // {
  //   path: "/departments",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <Department />
  //     </Suspense>
  //   ),
  // },
  {
    path: "/services",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Services />
      </Suspense>
    ),
  },

  {
    path: "/ipd-dashboard",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Dashboard />
      </Suspense>
    ),
  },
  {
    path: "/dashboard-forms",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DashboardForm />
      </Suspense>
    ),
  },
  {
    path: "/admission-information",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AdmissionInformation />
      </Suspense>
    ),
  },
  {
    path: "/emergency-form",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <EmergencyForm />
      </Suspense>
    ),
  },

  {
    path: "/death-form",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DeathForm />
      </Suspense>
    ),
  },
  {
    path: "/death-form/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DeathForm />
      </Suspense>
    ),
  },
  {
    path: "/change-room-services/:id",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <ChangeRoomServices />
      </Suspense>
    ),
  },
  {
    path: "/set-instructions",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Instruction />
      </Suspense>
    ),
  },
  {
    path: "/instruction-editor",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <InstructionEditor />
      </Suspense>
    ),
  },
  {
    path: "/ipd-details",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <TabbedForm />
      </Suspense>
    ),
  },
  {
    path: "/ipd-template",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Template />
      </Suspense>
    ),
  },
  {
    path: "/add-antibiotic",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Antibiotic />
      </Suspense>
    ),
  },
  {
    path: "/add-donor",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <BloodDonor />
      </Suspense>
    ),
  },
  {
    path: "/blood-bank",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <BloodBankDashboard />
      </Suspense>
    ),
  },
  {
    path: "/blood-bank/cross-match-report",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <CrossMatchReport />
      </Suspense>
    ),
  },
  {
    path: "/blood-bank/settings/:tab",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <BloodBankSettings />
      </Suspense>
    ),
  },
  {
    path: "/donor-bag",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <BagGeneration />
      </Suspense>
    ),
  },
  // {
  //   path: "/page-header",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <BloodDonorPageHeader />
  //     </Suspense>
  //   ),
  // },
  {
    path: "/donor-bag-expiry",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DonorBagExpiry />
      </Suspense>
    ),
  },
  {
    path: "/blood-bags",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <BagGeneration />
      </Suspense>
    ),
  },

  {
    path: "/donor-history",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DonorHistory />
      </Suspense>
    ),
  },
  {
    path: "/blood-products",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <BloodProducts />
      </Suspense>
    ),
  },
  {
    path: "/available-stock",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <AvailableStock />
      </Suspense>
    ),
  },
  {
    path: "/payment-statement",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PaymentStatement />
      </Suspense>
    ),
  },
  // {
  //   path: "/medical-questions",
  //   Content: () => (
  //     <Suspense fallback={<Preloader />}>
  //       <Questions />
  //     </Suspense>
  //   ),
  // },
  {
    path: "/patient-slip",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PatientSlipForm />
      </Suspense>
    ),
  },
  {
    path: "/donor-screening",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DonorScreening />
      </Suspense>
    ),
  },
  {
    path: "/donor-screening-reports",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <DonorScreeningTable />
      </Suspense>
    ),
  },

  {
    path: "/blood-crossmatch",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <BloodCrossmatch />
      </Suspense>
    ),
  },
  {
    path: "/cross-match-report",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <CrossMatchReport />
      </Suspense>
    ),
  },
  {
    path: "/pharmacy",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <Pharmacy />
      </Suspense>
    ),
  },
  {
    path: "/hospital-reports",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <HospitalReports />
      </Suspense>
    ),
  },
  {
    path: "/hospital-reports/ipd-admission-register",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <IpdAdmissionRegister />
      </Suspense>
    ),
  },
  {
    path: "/hospital-reports/patient-record-register",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <PatientRecordRegister />
      </Suspense>
    ),
  },
  {
    path: "/hospital-reports/radiology-summary",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <RadiologySummary />
      </Suspense>
    ),
  },
  // 404 Page
  {
    path: "*",
    Content: () => (
      <Suspense fallback={<Preloader />}>
        <NotFound />
      </Suspense>
    ),
  },
];
export default PrivatePaths;
